import { useLingui } from "@lingui/react";
import CheckIcon from "@uui/Check";

import MuiMenuItem from "@mui/material/MenuItem";
import styled from "@mui/material/styles/styled";

import { LOCALES, switchLocale } from "@app/locales";

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  borderRadius: theme.corners.base,
  color: theme.palette.shades.neutral[600],
  padding: theme.spacing(1),
  justifyContent: "space-between",
  "&.locale-menu__item--selected": {
    color: theme.palette.shades.neutral[800],
  },
  [theme.breakpoints.up("mobile")]: {
    width: "180px",
    "&:hover": {
      backgroundColor: "#F1F4FF",
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.shades.neutral[500],
      width: "16px",
      height: "16px",
    },
  },
  [theme.breakpoints.down("mobile")]: {
    ...theme.typography.bodyPrimaryReg,
    color: theme.palette.shades.neutral[800],
    display: "flex",
    border: `1px solid ${theme.palette.shades.neutral[100]}`,
    height: "44px",
    padding: theme.spacing(0.5, 1.5),
    "&.locale-menu__item--selected": {
      ...theme.typography.bodyPrimaryMed,
    },
    "& .MuiSvgIcon-root": {
      color: theme.palette.shades.neutral[500],
      height: "24px",
      width: "24px",
    },
  },
}));

interface LocaleMenuItemsProps {
  onClose: () => void;
}

/** Menu items (used by both Desktop and Mobile) */
const LocaleMenuItems = ({ onClose }: LocaleMenuItemsProps) => {
  const { i18n } = useLingui();

  return (
    <>
      {Object.entries(LOCALES).map(([languageCode, name]) => {
        const selected = i18n.locale === languageCode;

        return (
          <MenuItem
            key={languageCode}
            onClick={async () => {
              onClose();
              await switchLocale(languageCode);
            }}
            className={selected ? "locale-menu__item--selected" : undefined}
          >
            {name}
            {selected && <CheckIcon />}
          </MenuItem>
        );
      })}
    </>
  );
};

export default LocaleMenuItems;
